import https from './http.js'

// 个人简介
  const getUserInfo = (params) => https.post('api/index.UserInfo/index', params)
  // 文章列表
  const getArticles = (params) => https.post('api/index.Article/index', params)
  // 点击排行列表
  const getRecList = (params) => https.post('api/index.Article/top10_top', params)
  // 文章详情
  const getArticleDetail = (params) => https.post('api/index.Article/info', params)
  // 点击排行
  const getClickRank = (params) => https.post('api/index.Article/top10', params)
  // 分类标题列表
  const getCategoryList = (params) =>https.post('api/index.Classify/index', params)
	//暴露出这个对象
	export default{
    getUserInfo,
    getArticles,
    getRecList,
    getArticleDetail,
    getClickRank,
    getCategoryList
  };



// WEBPACK FOOTER //
// ./src/api/http.api.js